import { TDtoOrderTechnicalEntry } from "./__types__/TDtoOrderTechnicalEntry";
import { DtoTranslatesParser } from "./DtoTranslatesParser";
import { TParseDto } from "../__types__/dto";

export const DtoOrderTechnicalEntityParser: TParseDto<
  TDtoOrderTechnicalEntry
> = (data: any): TDtoOrderTechnicalEntry => ({
  core_id: Number(data.core_id),
  created_at: data.created_at ?? "",
  id: Number(data.id),
  key: data.key ?? "",
  restaurant: {
    domain: `https://${data.restaurant?.domain}` ?? "",
    id: data.restaurant.id,
    name: DtoTranslatesParser(data.restaurant.name),
  },
  status: Number(data.status),
  tenant_id: Number(data.tenant_id),
  updated_at: data.updated_at ?? "",
});
